import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, onMounted } from "vue";

import TextInput from "@/components/TextInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableInput',
  props: {
    title: {},
    inputValue: {},
    isEditable: { type: Boolean },
    placeholder: {}
  },
  setup(__props: any) {

const props = __props;

const editedValue = ref<string | undefined>(undefined);
onMounted(() => {
  editedValue.value = props.inputValue ?? props.title;
});

return (_ctx: any,_cache: any) => {
  return (props.isEditable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TextInput, {
          modelValue: editedValue.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((editedValue).value = $event)),
            _cache[1] || (_cache[1] = (t) => _ctx.$emit('update:model-value', t))
          ],
          value: editedValue.value,
          placeholder: props.placeholder
        }, null, 8, ["modelValue", "value", "placeholder"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.title), 1))
}
}

})